import { CommonButton } from "@components/CommonButton";
import report from "@report";
import { USER_BIZ_COUNTRY_MAP } from "@src/config/country";
import { updateSubscribeProducts } from "@store/memberCenterSlice";
import { Modal } from "antd";
import { Trans } from "react-i18next";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { formatCurrency, getGasStationPrice } from "@pages/pricing/utils";
import IndenpendentProduct from "./IndenpendentProduct";
import { GtmPayNowParams, pushGtmPayNow } from "@utils/gtm";

interface CreditModalProps {
  goPay: () => void;
}

const CreditModal = ({ goPay }: CreditModalProps) => {
  const dispatch = useAppDispatch();
  const { userInfo, language } = useAppSelector((state) => state.globalReducer);
  const { selectedProducts } = useAppSelector((state) => state.memberCenterReducer);

  const { bizCountry } = userInfo;

  const currency = "USD";
  const selectedProduct = selectedProducts[0] ?? { quantity: 0 };
  const { quantity } = selectedProduct;
  const unitPrice = getGasStationPrice(
    selectedProduct.key,
    USER_BIZ_COUNTRY_MAP[bizCountry],
    currency,
    selectedProduct.realprice,
  );
  const total = unitPrice * quantity;
  const AI_CREDITS_PER_UNIT = 100;
  const credits = AI_CREDITS_PER_UNIT * quantity;
  const payNowParams: GtmPayNowParams = {
    quantity,
    total,
    credits,
    currency,
    unit_price: unitPrice,
    item_id: selectedProduct.itemId,
    product_key: selectedProduct.key,
    region: selectedProduct.region,
    realprice: selectedProduct.realprice,
  };

  return (
    <div>
      <Modal
        title={
          <div className="text-kds-fg font-bold text-[16px]">
            <Trans>Get More Credits</Trans>
          </div>
        }
        open={true}
        centered={true}
        onCancel={() => {
          dispatch(updateSubscribeProducts([]));
        }}
        styles={{ header: { marginBottom: 8 } }}
        footer={
          <div className="flex justify-end items-end gap-[16px]">
            {quantity > 0 && (
              <>
                <div className="flex items-baseline gap-[4px]">
                  <span className="text-[14px] font-normal text-kds-fg-soft">
                    <Trans>Subtotal</Trans>
                  </span>
                  <div className="text-[24px] font-bold text-kds-fg leading-[24px]">
                    {formatCurrency(total, USER_BIZ_COUNTRY_MAP[bizCountry], currency, language)}
                  </div>
                </div>
              </>
            )}
            <CommonButton
              size="large"
              className="min-w-[144px]"
              disabled={quantity === 0}
              onClick={() => {
                report.event("kalo_click", { kalo_type: "pay_for_ai_credits", kalo_value: "kaloclip" });
                pushGtmPayNow(payNowParams);
                goPay();
              }}
              type="primary"
            >
              <Trans>Pay Now</Trans>
            </CommonButton>
          </div>
        }
      >
        <div className="text-kds-fg text-[14px]">
          <Trans>Top up your credits and gear up for your next viral hit!</Trans>
        </div>
        {selectedProducts.map((product, index) => {
          return <IndenpendentProduct key={product.itemId} product={product} index={index}></IndenpendentProduct>;
        })}
      </Modal>
    </div>
  );
};

export default CreditModal;
